export type ProjectSecondaryResourceCandidate = {
  provider?: string | null;
  resourceType?: string | null;
  brandIds?: string[] | null;
};

const CANONICAL_SECONDARY_RESOURCE_BY_PROVIDER: Record<string, string> = {
  google: "CUSTOMER",
  googleads: "CUSTOMER",
  googleanalytics: "PROPERTY",
  googlesearchconsole: "SITE",
};

const normalizeProviderKey = (provider?: string | null) =>
  String(provider || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const isCanonicalProjectSecondaryResource = (
  provider?: string | null,
  resourceType?: string | null,
) =>
  CANONICAL_SECONDARY_RESOURCE_BY_PROVIDER[normalizeProviderKey(provider)] ===
  String(resourceType || "").trim().toUpperCase();

export const getCanonicalProjectSecondaryResources = <T extends ProjectSecondaryResourceCandidate>(
  resources: T[],
): T[] => resources.filter((resource) =>
  isCanonicalProjectSecondaryResource(resource.provider, resource.resourceType),
);

export const hasAssignedCanonicalProjectSecondaryResource = (
  provider: string | null | undefined,
  resources: ProjectSecondaryResourceCandidate[],
  brandId: string,
) => resources.some((resource) =>
  isCanonicalProjectSecondaryResource(resource.provider || provider, resource.resourceType) &&
  (resource.brandIds || []).includes(brandId),
);
